<div class="contact">
  <app-breadcrumbs></app-breadcrumbs>
  <!-- Decorative gradients/orbs to match main hero -->
  <svg
    class="hero-orb orb-a"
    viewBox="0 0 400 400"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <radialGradient id="contactOrbGradientA" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#75b6e7" stop-opacity="0.6" />
        <stop offset="100%" stop-color="#75b6e7" stop-opacity="0" />
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#contactOrbGradientA)" />
  </svg>
  <svg
    class="hero-orb orb-b"
    viewBox="0 0 400 400"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <radialGradient id="contactOrbGradientB" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#ffffff" stop-opacity="0.35" />
        <stop offset="100%" stop-color="#ffffff" stop-opacity="0" />
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#contactOrbGradientB)" />
  </svg>
  <!-- Subtle wave to transition into the content below (match main) -->
  <svg
    class="hero-wave"
    viewBox="0 0 1440 120"
    preserveAspectRatio="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z"
      fill="#f6f6f6"
    ></path>
  </svg>
</div>

<!-- Title Container -->
<div class="title-container-1">
  <div class="title-container-2">
    <div class="search-text">Contact</div>
  </div>
</div>

<!-- Contact Methods Section -->
<div
  class="mx-auto max-w-[1200px] px-[25px] pb-[100px] bg-[#f6f6f6] animate-on-scroll animate-hidden lg:px-6 lg:pb-20 md:px-4 md:pb-[60px]"
>
  <section class="flex flex-col lg:flex-row items-stretch gap-8 lg:gap-16">
    <!-- Content -->
    <div
      class="flex-1 flex flex-col justify-center py-0 text-center lg:text-left order-2 lg:order-1"
    >
      <span class="eyebrow">Neem contact op</span>
      <h2 class="split-hero__title">Direct contact, op jouw manier.</h2>

      <ul class="contact-list">
        <li>
          <button type="button" class="contact-list__row" (click)="whatsapp('31798080328')" aria-label="Open WhatsApp">
            <span class="contact-list__icon contact-list__icon--whatsapp">
              <icon name="whatsapp"></icon>
            </span>
            <span class="contact-list__content">
              <span class="contact-list__label">WhatsApp</span>
              <span class="contact-list__value">{{ whatsAppNumber }}</span>
            </span>
            <span class="contact-list__action">Stuur bericht <icon class="contact-list__chevron" name="navigate_next" aria-hidden="true"></icon></span>
          </button>
        </li>
        <li>
          <button type="button" class="contact-list__row" (click)="phoneCall('31798080320')" aria-label="Bel Blauwtand">
            <span class="contact-list__icon contact-list__icon--phone">
              <icon name="call_filled"></icon>
            </span>
            <span class="contact-list__content">
              <span class="contact-list__label">Bellen</span>
              <span class="contact-list__value">{{ phoneNumber }}</span>
            </span>
            <span class="contact-list__action">Bel nu <icon class="contact-list__chevron" name="navigate_next" aria-hidden="true"></icon></span>
          </button>
        </li>
        <li>
          <button type="button" class="contact-list__row" (click)="email('info@blauwtand.com')" aria-label="Mail Blauwtand">
            <span class="contact-list__icon contact-list__icon--email">
              <icon name="email_filled"></icon>
            </span>
            <span class="contact-list__content">
              <span class="contact-list__label">E-mail</span>
              <span class="contact-list__value">info&#64;blauwtand.com</span>
            </span>
            <span class="contact-list__action">Mail ons <icon class="contact-list__chevron" name="navigate_next" aria-hidden="true"></icon></span>
          </button>
        </li>
        <li>
          <button type="button" class="contact-list__row" (click)="googleMapsOffice()" aria-label="Route naar kantoor">
            <span class="contact-list__icon contact-list__icon--route">
              <icon name="location_on_filled"></icon>
            </span>
            <span class="contact-list__content">
              <span class="contact-list__label">Route</span>
              <span class="contact-list__value">Bredewater 26, 2715 CA Zoetermeer</span>
            </span>
            <span class="contact-list__action">Open in Maps <icon class="contact-list__chevron" name="navigate_next" aria-hidden="true"></icon></span>
          </button>
        </li>
      </ul>

      <!-- Social Links -->
      <div class="contact-social-wrap">
        <p class="eyebrow eyebrow--sm">Of volg ons online</p>
        <app-social-links
          [showEmail]="false"
          [showPhone]="false"
          [showWhatsApp]="false"
          [showLinkedIn]="true"
          [showFacebook]="true"
          [showInstagram]="true"
          linkedin="https://www.linkedin.com/company/blauwtand/"
          shareUrl="https://blauwtand.com"
        ></app-social-links>
      </div>
    </div>

    <!-- Image -->
    <div
      class="flex-[1.8] relative overflow-hidden rounded-[20px] self-center min-h-[250px] lg:min-h-0 lg:max-h-[500px] w-full aspect-[4/3] lg:aspect-auto order-1 lg:order-2"
    >
      <img
        src="./assets/contact.webp"
        alt="Kantoor Blauwtand"
        loading="lazy"
        class="w-full h-full object-cover object-center"
      />
    </div>
  </section>
</div>
